import React, { Component } from 'react'
import BoxItem from "./BoxItem"

class BoxItemContainer extends Component {

    render() {
        const { boxes, onGetInfoBox, selectedItems, onChangeSelected, handleChangeSelect, emptyText } = this.props
        return (
            <tbody>
                {
                    boxes.map(box => {
                        const { _id: boxId } = box
                        return (
                            <BoxItem
                                key={boxId}
                                box={box}
                                onGetInfoBox={onGetInfoBox}
                                selectedItems={selectedItems}
                                onChangeSelected={onChangeSelected}
                                handleChangeSelect={handleChangeSelect}
                            />
                        )
                    })
                }

                {
                    !boxes.length && <tr>
                        <td colSpan={14} className="NotFound">{emptyText || 'Không tìm thấy thùng nào!'}</td>
                    </tr>
                }
            </tbody>
        )
    }
}

export default BoxItemContainer
